export const BACKGROUND_SHADE_T0: string = "#374247"
export const BACKGROUND_SHADE_T1: string = "#2b3438"
export const MENU_WIDTH: string = "max(35vw, min(500px, 100%))"
export const ACCENT_COLOR_SATURATION: number = 20
export const ACCENT_COLOR_LIGHTNESS: number = 40
export const RED_SHADE_T0: string = "#77525a"